import * as gridLayout from "./action-type";

//切换编辑状态
export const toggleEditStatus = (data) => {
    return {
        type: gridLayout.TOGGLE_EDIT_STATUS,
        data,
    };
};

//设置layouts数据
export const setLayouts = (index, data) => {
    return {
        type: gridLayout.SET_LAYOUTS,
        data: {
            index,
            data,
        },
    };
};

//设置正在拖拽的item
export const setDraggingItems = (data) => {
    return {
        type: gridLayout.SET_DRAGGING_ITEMS,
        data,
    };
};
// 清空数据
export const clearData = () => {
    return {
        type: gridLayout.CLEAR_DATA,
    };
};
// 更新选中siderCard
export const updateShadowCard = (shadowCard) => {
    return {
        type: gridLayout.UPDATE_SHADOWCARD,
        shadowCard: shadowCard,
    };
};
//更新GroupList数据
export const updateGroupList = (groups) => {
    return {
        type: gridLayout.UPDATE_GROUP_LIST,
        groups: groups,
    };
};
//更新正在编辑的分组ID
export const updateCurrEditID = (currEditID) => {
    return {
        type: gridLayout.UPDATE_CURREDITID,
        currEditID: currEditID,
    };
};

//初始化时候的Groups
export const initGroups = (initialGroups) => {
    return {
        type: gridLayout.INIT_GROUPS,
        initialGroups: _.cloneDeep(initialGroups),
    };
};
//多语
export const setJson = (json) => {
    return {
        type: gridLayout.JSON,
        json: json,
    };
};
//更新左侧已选卡片
export const updateSelectedCards = (cardList) => {
    return {
        type: gridLayout.UPDATE_SELECTED_CARDS,
        selectedCards: cardList,
    };
};
// 更新首页
export const setUpdateHomePageFun = (data) => {
    return {
        type: gridLayout.UPDATE_HOMEPAGE,
        updateHomePage: data
    };
};
// 是否无应用
export const setEmpty = (data) => {
    return {
        type: gridLayout.SET_EMPTY,
        showEmpty: data
    };
};
// 去重窗口显示切换
export const toggleDeduplicateModal = (deduplicateModalVisible) => {
    return {
        type: gridLayout.TOGGLE_DEDUPLICATE_MODAL,
        deduplicateModalVisible
    }
}
//设置GridLayout是否可drop
export const setDroppable = (isDroppable) => {
    return {
        type: gridLayout.SET_DROPPABLE,
        isDroppable
    }
}
//设置GridLayout的间隔margin
export const setGridMargin = (margin) => {
    return {
        type: gridLayout.SET_GRID_MARGIN,
        margin
    }
}
//设置GridItem拖拽状态
export const setGroupDragable = (groupCanDrag) => {
    return {
        type: gridLayout.SET_GROUP_DRAGABLE,
        groupCanDrag
    }
}
//设置GridItem拖拽状态
export const setAppGroupData = (key, data) => {
    return {
        type: gridLayout.SET_APP_GROUP_DATA,
        key,
        data
    }
}
//设置正在拖拽的聚合应用item
export const setDraggingAppGroupItem = (draggingAppGroupItem) => {
    return {
        type: gridLayout.SET_DRAGGING_APPGROUP_ITEM,
        draggingAppGroupItem
    }
}
//设置帮助信息提示
export const setHelpHint = (isShowHelpHint) => {
    return {
        type: gridLayout.SET_HELP_HINT,
        isShowHelpHint
    }
}
//设置放置的聚合应用
export const setDroppedAppGroupItem = (id, data, callback) => {
    return {
        type: gridLayout.SET_DROPPED_ITEM,
        id,
        data,
        callback
    }
}
//设置默认聚合应用数据
export const setDefaultAppGroupData = (defaultAppGroupData) => {
    return {
        type: gridLayout.SET_DEFAULT_APP_GROUP_DATA,
        defaultAppGroupData
    }
}
//设置桌面保存成功标识
export const setSaveComplete = (isSaveComplete) => {
    return {
        type: gridLayout.SET_SAVE_COMPLETE_FLAG,
        isSaveComplete
    }
}
//设置设置更新布局标识
export const setUpdateLayout = (isUpdateLayout) => {
    return {
        type: gridLayout.UPDATE_LAYOUT_FLAG,
        isUpdateLayout
    }
}
//设置左栏收起状态
export const setSiderCollapsed = (siderCollapsed) => {
    return {
        type: gridLayout.SET_SIDER_COLLAPSED,
        siderCollapsed
    }
}
//设置左栏帮助提示显隐
export const setLeftHelpTipVisible = (helpTipVisible) => {
    return {
        type: gridLayout.SET_LEFT_HELPTIP,
        helpTipVisible
    }
}
//常用链接
export const setExternalLinks = (externalData) => {
    let newExternalData = externalData;
    if (externalData != null) {
        const data = {
            name: externalData.name || externalData.title,
            url: externalData.url || externalData.urllink || ''
        }
        newExternalData = { ...externalData, ...data }
    }
    return {
        type: gridLayout.SAVE_EXTERNAL_LINK_DATA,
        externalData: newExternalData,
    }
}
//设置是否职责桌面
export const setRespWorkbench = (isRespWorkbench) => {
    return {
        type: gridLayout.IS_RESP_WORKBENCH,
        isRespWorkbench
    }
}
//设置dragOver的分组
export const setDragOverGroup = (dragOverGroupItem) => {
    return {
        type: gridLayout.SET_DRAGOVER_GROUP,
        dragOverGroupItem
    }
}
// 更新侧拉编辑状态（是否有正在编辑的侧拉面板）
export const updateEditSiderStatus = (hasEditingSider) => {
    return {
        type: gridLayout.UPDATE_EDITING_SIDER_STATUS,
        hasEditingSider
    }
}
// 设置工作台整体配置
export const setWorkbenchConfig = (workbenchConfig) => {
    return {
        type: gridLayout.SET_WORKBENCH_CONFIG,
        workbenchConfig
    }
}
// 更新layout-app属性
// data { groupIndex, id, properties, replace }
export const updateAppProperties = (data) => {
    return {
        type: gridLayout.UPDATE_APP_PROPERTIES,
        data
    }
}